import { render, staticRenderFns } from "./submit-button.vue?vue&type=template&id=272f2619&scoped=true"
import script from "./submit-button.vue?vue&type=script&lang=js"
export * from "./submit-button.vue?vue&type=script&lang=js"
import style0 from "./submit-button.vue?vue&type=style&index=0&id=272f2619&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272f2619",
  null
  
)

export default component.exports